<template>
  <svg
    width="33"
    height="70%"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.333 3.99982L4.33301 12.3998V25.5998C4.33301 26.2363 4.57884 26.8468 5.01643 27.2969C5.45401 27.747 6.0475 27.9998 6.66634 27.9998H25.9997C26.6185 27.9998 27.212 27.747 27.6496 27.2969C28.0872 26.8468 28.333 26.2363 28.333 25.5998V12.3998L16.333 3.99982Z" fill="#5C53A2"/>
    <path
      d="M9.08398 27.0266V15.5447H23.7326V27.0266"
      stroke="#F1F0FF"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M19.338 24.3337H13.4785"
      stroke="#F1F0FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.338 19.9392H13.4785"
      stroke="#F1F0FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
